import React from 'react';
import Modal from '../../Components/Modal';
import { useJob } from '../../Data/Jobs';
import { PageLoading } from '../../Components/Loading';
import DateTime from '../../Components/Formatting/DateTime';
import ButtonRow from '../../Components/Button/ButtonRow';
import Button from '../../Components/Button/Button';

const JobHistory = ({job, onClose}) => {
    return <Modal title="Job History" isOpen={!!job} setIsOpen={onClose} dismissible>
        <div className="max-h-[50vh] overflow-y-auto">
            {job && <Inner jobId={job.id} />}
        </div>
        <ButtonRow>
            <Button theme="secondary" label="Close" onClick={onClose} />
        </ButtonRow>
    </Modal>
}

const Inner = ({jobId}) => {
    const {job} = useJob(jobId, true);

    if (!job) {
        return <PageLoading />;
    }

    if (!job.occurrences || job.occurrences.length === 0) {
        return <p className="text-muted text-center py-5">No history</p>
    }

    return <ul className="divide-y divide-gray-200">
        {job.occurrences.map((o, i) => {
            return <li className="gap-x-6 py-5 flex flex-row justify-between">
                <div>
                    <strong>
                        {o.doneAt ? <DateTime date={o.doneAt} /> : <span className="text-muted">To be completed</span>
                    }</strong><br />
                    <span className="text-muted">{o.notes ?? '[No notes]'}</span>
                </div>
                <div>
                    {o.status}
                </div>
            </li>
        })}
    </ul>
}

export default JobHistory;
